import { style } from '@vanilla-extract/css';

export const postContentElement = style({
  margin: 'auto',
  maxWidth: 'var(--max-width, 672px)',
  position: 'relative',
  textAlign: 'start',
});
